import http from './http'

class User {
  fetch () {
    return http.get('/users')
  }

  get (id) {
    return http.get(`/users/${id}`)
  }

  update (payload) {
    return http.put(`/users/${payload.id}`, { user: payload })
  }

  save (payload) {
    return http.post('/users', { user: payload })
  }

  saveByToken (token, user) {
    return http.post(`/user_payers/${token}`, { user })
  }

  findByToken (token) {
    return http.get(`/user_payers/token/${token}`)
  }

  switchCurrent (payload) {
    return http.post('/switch_user_in', { switch_user: payload })
  }

  resetSwitch () {
    return http.get('/switch_user_out')
  }
}

export default new User()



// WEBPACK FOOTER //
// ./src/services/user.js